<script>
  import { replace, link } from 'svelte-spa-router'
  import { userStore } from '../state/store'
  import { language, toggleLanguage, t } from '../i18n/i18n'
  import { isUserAdmin } from '../helpers/utils'
  import active from 'svelte-spa-router/active'
  import Icon from './Icon.svelte';
  import { onMount } from 'svelte';

  const logout = () => {
    sessionStorage.clear()
    userStore.set({})
    replace('/sign-in/')
  }
  let dropdown = false
  const toggleDropdown = (force = null) => {
    dropdown = force !== null ? force : !dropdown
  }
  const dropdownBlur = (e) => {
    if (!e.target.classList.contains('dropdown-trigger')) {
      toggleDropdown(false)
    }
  }
  onMount(() => {
    document.addEventListener('click', dropdownBlur)
    return () => {
      document.removeEventListener('click', dropdownBlur)
    }
  })
</script>

<style>
  
  div {
    background: var(--blue);
    display: flex;
    justify-content: center;
  }

  nav {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 2rem;
    font-size: 1.9rem;
    max-width: 120rem;
    width: 100%;
    height: 6rem;
  }

  @media (min-width: 1200px) {
  nav {
    padding: 0;
  }
}

  ul {
    display: flex;
    flex: 1;
  }

  @media (min-width: 400px) {
    ul {
      justify-content: center;
    }
  }

  .main-links li {
    font-weight: bold;
    margin-left: 1.5rem;
    text-transform: capitalize;
  }

  .main-links li:first-child {
    margin-left: 0;
  }

  a {
    color: #959595;
    text-decoration: none;
    font-weight: normal;
  }

  .active {
    color: var(--white);
  }

  a:hover:not(.active)  {
    color: var(--white);
  }
  .sub-links button, 
  .sub-links a {
    color: var(--blue);
    text-decoration: none;
    text-transform: capitalize;
  }
  .lang-toggle {
    background-color: var(--white);
    border: none;
    border-radius: 90rem;
    width: 3.2rem;
    height: 3.2rem;
    background: var(--white);
    color: var(--blue);
    padding-bottom: 0.3rem;
    margin: 0 1.2rem;
    text-align: center;
    flex-grow: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
  .account-icon {
    color: var(--white);
    display: inline-block;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3.2rem;
    padding-bottom: 1.2rem;
  }

  img {
    display: none;
  }

  @media (min-width: 400px) {
    img {
      width: 3.2rem;
      display: initial;
    }    
  }

  .dropdown-parent {
    position: relative;
    color: var(--grey);
    height: 100%;
  }
  .dropdown {
    position: absolute;
    padding: 2rem;
    z-index: 10;
    text-align: left;
    right: 0;
    top: 100%;
    background-color: var(--white);
    display: none;
    box-shadow: 0 0 1rem 0.5rem rgba(100, 100, 100, 0.2);
  }
  .dropdown::before {
    content: '';
    border-bottom: 1rem solid var(--white);
    border-left: 1rem solid transparent;
    border-right: 1rem solid transparent;
    position: absolute;
    bottom: 100%;
    right: 1rem;
  }
  .dropdown.active {
    display: block;
  }
  .dropdown li + li {
    margin-top: 1rem;
  }

  .dropdown a:hover {
    color: var(--blue);
  }
</style>
<div>
  <nav>
    <img src='logo-white.svg' alt='Contract Keeper'>
    <ul class="main-links">
      {#if $userStore.status === 'active' || $userStore.status === 'trialing' }
        <li><a href='/locations/' use:link use:active={'/locations/*'}>{$t.locations}</a></li>
      {/if}
      {#if isUserAdmin($userStore) && $userStore.status === 'active' || $userStore.status === 'trialing'}
        <li><a href='/clients/' use:link use:active={'/clients/*'}>{$t.clients}</a></li>
        <li><a href='/people/' use:link use:active={'/people/*'}>{$t.people}</a></li>
        <li><a href='/daily-report/' use:link use:active={'/daily-report/*'}>{$t.daily_report}</a></li>
      {/if} 
    </ul>
    <button class="lang-toggle" on:click={toggleLanguage}>{$language == 'en' ? 'fr' : 'en'}</button>
    <div class="dropdown-parent">
      <button class="g-unbutton account-icon dropdown-trigger" on:click={() => toggleDropdown()}><Icon name='account_circle'/></button>
      <ul class="dropdown sub-links" class:active={dropdown}>
        {#if isUserAdmin($userStore)}
          <li><a href='/settings/' use:link use:active={'/settings/*'}>{$t.settings}</a></li>
        {/if}
        <li>
          <button class="g-unbutton" on:click={logout}>{$t.logout}</button>
        </li>
      </ul>
    </div>
  </nav>
</div>